import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import './UserInquiry.css'

class EmptyRecords extends Component {

    render() {
        return (
            <div className="container-fluid">
                <div className="row text-center no-records-div">
                    <br/>
                    <FormattedMessage id="app.inquiry-row.no-records"
                                      defaultMessage="No records available at the moment"
                                      description=""/>
                    {/*<hr/>*/}
                </div>
            </div>
        )
    }
}
export default EmptyRecords;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/EmptyRecords.js